import React from 'react';
import {createRoot} from 'react-dom/client'
// Imports
import  AppSWT  from "./appSWT.jsx";

const react_app_wrapper = document.querySelector("#decisionTree__app-wrapper");
const root= createRoot(react_app_wrapper)
// Don't run on a non-React page
if (react_app_wrapper !== null) {
  root.render(
    <div className="react__app-content">
      <AppSWT />
    </div>,
  );
}
